import React, {useContext} from 'react'
import {Link} from 'gatsby'
import styled from 'styled-components'

import {StateContext} from '../../utils/context'

export default ({to, title, isTop}) => {
  const {state, dispatch} = useContext(StateContext)
  return (
    <Flip>
      <PageLink 
        to={to}
        onClick={e => state.isHeaderMenuActive ? dispatch({type: 'HeaderMenuActive', payload: false}) : null}
        is_top={isTop ? 'true' : undefined}
        header_active={state.isHeaderMenuActive ? 'true' : undefined}
      >
        <div className="front" is_top={isTop ? 'true' : undefined} header_active={state.isHeaderMenuActive ? 'true' : undefined}>{title}</div>
        <div className="back" is_top={isTop ? 'true' : undefined} header_active={state.isHeaderMenuActive ? 'true' : undefined}>{title}</div>
      </PageLink>
    </Flip>
  )
}

const Flip = styled.div`
  width: 100%;
  height: 100%;
  perspective: 500px;
  @media(min-width: 900px) {
    width: 160px;
    height: 48px;
  }
`
const PageLink = styled(Link)`
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  transform: translateZ(-25px);
  transition: transform 0.3s;
  cursor: pointer;
  .front,
  .back {
    margin: 0;
    width: 160px;
    height: 48px;
    width: 100%;
    height: 100%;
    line-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    text-align: center;
    letter-spacing: .4em;
    @media(min-width: 900px) {
      width: 160px;
      height: 48px;
      line-height: 48px;
    }
  }
  .front {
    background-color: ${props => props.is_top ? props.theme.white :  props.header_active ? props.theme.white : 'transparent'};
    color: ${props => props.is_top ? props.theme.green : props.header_active ? props.theme.green : props.theme.white};
    transform: rotateY(0) translateZ(24px);
  }
  .back {
    color: ${props => props.is_top ? props.theme.white : props.header_active ? props.theme.white : 'transparent'};
    transform: rotateX(90deg) translateZ(24px);
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      top: -32%;
      left: -10%;
      width: 120%;
      height: 50%;
      background-color: ${props => props.is_top ? props.theme.white : props.header_active ? props.theme.white: props.theme.green};
      transform: rotate(8deg);
      transition: all .5s ease;
      transition-delay: .15s;
    }
    @media(min-width: 900px) {
      width: 160px;
      height: 48px;
      background-color: ${props => props.is_top ? props.theme.green : props.header_active ? props.theme.green : props.theme.white};
    }
  }
  &:hover {
    transform: translateZ(-24px) rotateX(-90deg);
    .front{
      background-color: ${props => props.theme.white};
      transition: all .8s ease;
    }
    .back{
      color: ${props => props.is_top ? props.theme.white : props.header_active ?  props.theme.white : props.theme.green};
      transition: color .4s linear;
      background-color: ${props => props.is_top ? props.theme.green : props.header_active ?  props.theme.green : props.theme.white};
      &:after {
        transform: rotate(6deg) translate(100px,-18px);
      }
    }
  }
`